import React from "react";
import { RouteComponentProps } from "react-router";
import { connect } from "react-redux";
import { WithStyles, withStyles, Grid } from "material-ui";

import {
    getAllAccounts,
    getAllAccountsToDeposit,
    getSelectedAccount,
    getAllAccountsData,
    Accounts,
} from "../../ducks/account";
import {
    SetHeader,
    ShowLogo,
    ShowBackNavigationWithRoute,
    SetShowBackNavigation,
} from "../../ducks/common";
import { ReduxState, ReduxDispatch } from "../../ducks/reducers";
import {
    SetActionButtonAndShow,
    SetShowActionButton,
    ResetActionButtonClicked,
    actionButtonClicked,
} from "../../ducks/actionbutton";
import { submit } from "redux-form";
import DepositForm, { DepositFormData } from "./components/depositForm";
import { IsCordova } from "util/platformUtils";
import { showSnackbar } from "ducks/snackbar";

const styles = {} as React.CSSProperties;

interface DepositPageProps extends RouteComponentProps<{ id: string }> {}

interface DepositPageReduxProps {
    selectedAccount: string;
    accountsData: Accounts;
}

interface DepositPageDispatchProps {
    setHeaderValue: (header: string) => void;
    showLogo: (show: boolean) => void;
    setBackButton: (route: string) => void;
    hideBackButton: () => void;
    getAccountsData: () => void;
    showSnack: (text: string) => void;
}

interface DepositPageState {
    showRef: boolean;
}

type DepositPageConnectedProps = DepositPageProps &
    DepositPageReduxProps &
    DepositPageDispatchProps;

type DepositPagePropsWithStyles = DepositPageConnectedProps & WithStyles<"">;

class DepositPage extends React.Component<
    DepositPagePropsWithStyles,
    DepositPageState
> {
    hiddenInput: HTMLInputElement;

    constructor(props: DepositPagePropsWithStyles) {
        super(props);

        this.state = {
            showRef: false,
        };
    }

    componentDidMount() {
        this.props.showLogo(false);
        //this.props.setBackButton(`/account/${this.props.match.params.id}`);
        this.props.setBackButton("");
        this.props.setHeaderValue("Talletusohje");
        this.props.getAccountsData();
    }

    componentWillUnmount() {
        this.props.showLogo(true);
        this.props.hideBackButton();
    }

    componentWillReceiveProps(nextProps: DepositPagePropsWithStyles) {}

    copyRef = () => {
        this.setState(
            {
                showRef: true,
            },
            () => {
                if (IsCordova) {
                    cordova.plugins.clipboard.copy(this.hiddenInput.value);
                    this.props.showSnack("Viite kopioitu leikepöydälle");
                } else {
                    this.hiddenInput.focus();
                    this.hiddenInput.select();

                    document.execCommand("copy");
                }
                this.setState({
                    showRef: false,
                });
            }
        );
    };

    render() {
        const { classes } = this.props;
        const accounts = Object.keys(this.props.accountsData).map((key) => {
            const acc = this.props.accountsData[key];
            const label = acc.accountName
                ? `${acc.accountName} - ${acc.accountNumber}`
                : `${acc.accountNumber}`;
            return { label: label, value: key };
        });

        const refNum =
            this.props.accountsData &&
            this.props.selectedAccount &&
            this.props.accountsData[this.props.selectedAccount] &&
            this.props.accountsData[this.props.selectedAccount].referenceNumber;

        return (
            <div className="page-container">
                <DepositForm
                    allAccountsList={accounts}
                    selectedAccountData={
                        this.props.accountsData[this.props.selectedAccount]
                    }
                    initialValues={{
                        accountNumber: this.props.match.params.id,
                    }}
                    copyRef={this.copyRef}
                    form="depositForm"
                />
                {this.state.showRef && (
                    <input
                        ref={(c) => (this.hiddenInput = c!)}
                        type="text"
                        defaultValue={`${refNum}`}
                    />
                )}
            </div>
        );
    }
}

const mapStateToProps = (
    state: ReduxState,
    props: DepositPagePropsWithStyles
): DepositPageReduxProps => {
    return {
        selectedAccount: getSelectedAccount(state, "depositForm"),
        accountsData: getAllAccountsToDeposit(state),
    };
};

const mapDispatchToProps = (
    dispatch: ReduxDispatch
): DepositPageDispatchProps => {
    return {
        setHeaderValue: (header) => {
            return dispatch(SetHeader(header));
        },
        showLogo: (show: boolean) => {
            return dispatch(ShowLogo(show));
        },
        setBackButton: (route: string) => {
            dispatch(ShowBackNavigationWithRoute(route));
        },
        hideBackButton: () => {
            dispatch(SetShowBackNavigation(false));
        },
        getAccountsData: () => {
            dispatch(getAllAccounts(true));
        },
        showSnack: (text: string) => {
            dispatch(showSnackbar(text));
        },
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(DepositPage));



// WEBPACK FOOTER //
// ./src/views/account/DepositPage.tsx